import { Reducer as Reducer_ } from 'redux';
import { HealthCheckModel as HealthCheckModel_, IHealthCheckActionType as IHealthCheckActionType_ } from '../actions/health-check-actions';
import * as types from '../actions/actionTypes/health-check';

/* eslint-disable max-len */
const healthCheckReducer: Reducer_<HealthCheckModel_, IHealthCheckActionType_> = (state = { isChecked: false, status: 200, }, { type, payload, }) => {
  switch (type) {
    case types.HEALTH_CHECK_SUCCESS:
      return { ...payload, };
    case types.HEALTH_CHECK_FAIL:
      return { ...payload, };

    default:
      return state;
  }
};

export default healthCheckReducer;
